import request from '@/utils/request'

export function getMoreDetail(params) {
  return request.get('/app/more/detail', params)
}

export function getMoreList(params) {
  return request.get('/app/more/list', params)
}
